import moment from "moment";

const beautifyNames = function(name) {
  if (name) {
    name = name.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
  }
  return name;
}
/*
  Recibe el objeto locations_information, que llega en MMB / WCK
  llegan con id XXX_0, se convierte a XX y se retorna el mismo objeto
  que en FResult
*/
const getParseAirports = function (locations_information) {
  const data = locations_information
  const result = {}
  Object.keys(data).forEach(function (prop) {
    // `prop` is the property name
    var obj = {}
    // lo agrego porq no viene -----------------------
    data[prop].description = data[prop].location_name
    // -----------------------------------------------
    obj[prop.split('_')[0]] = data[prop]
    Object.assign(result, obj)
  })
  return result
}

const getAirportName = function(code) {
  code = code.split('_')[0]
  const label = `airport_name_${code}`
  const resAirportInfo = this.airports[code] ? this.airports[code] : this.airports.airports[code]
  const resAirportName = resAirportInfo ? resAirportInfo.description : code
  return Object.keys(this._i18n.messages).find(lang => {
    return label !== this._i18n.t(label, lang)
  }) ? label : resAirportName
}

const getCityName = function(code) {
  code = code.split('_')[0]
  const label = `city_name_${code}`
  const resAirportInfo = this.airports[code] ? this.airports[code] : this.airports.airports[code]
  const resCityName = resAirportInfo ? resAirportInfo.city.description : code
  return Object.keys(this._i18n.messages).find(lang => {
    return label !== this._i18n.t(label, lang)
  }) ? label : resCityName
}

const removeSeconds = function(time) {
  return `${time.split(':')[0]}:${time.split(':')[1]}`
}

const currentDateFormat = function(locale) {
  const format = this.$i18n.messages[locale].date_format

  const default_date = 'DD/MM/YYYY'

  return format ? format : default_date
}

const i18nParse = (object, lang, value, keyLang) => {
  if (keyLang) {
    if (object[lang]) {
      return object[lang]
    } else {
      let objectKeys = Object.keys(object)
      return object[objectKeys[0]]
    }
  } else {
    if (typeof object === 'string') {
      value = object
    } else {
      if (object) {
        object.forEach(title => {
          if (title.code === lang) {
            value = title.value
          }
        })
      }
    }
    return value
  }
}

const getFormatedTime = function (time) {
  const splitted = time.split(':')
  const hours = Number(splitted[0])
  const minutes = Number(splitted[1])
  return `${hours}h ${minutes !== 0 ? minutes + 'min' : ''}`
}


const formatNumberAmount = function (amount) {
  let val = new Intl.NumberFormat()
  return val.format(amount)
}

const preventTabKey = function(e, refs, where) {
  refs[where].focus();
  if(e) {
    e.preventDefault();
  }
}

String.prototype.replaceAll = function(search, replacement) {
  var target = this;
  return target.split(search).join(replacement);
};

export { beautifyNames, getAirportName, getCityName, removeSeconds, getFormatedTime, formatNumberAmount, preventTabKey, i18nParse, currentDateFormat, getParseAirports }
